/**
 * Pontos de foco da lista de conversas, para a casca (layout) devolver o foco à lista sem
 * conhecer o HTML das linhas. Ficam aqui, junto de quem renderiza esses atributos.
 */

/**
 * Atributo do link de cada conversa com o id dela (o `href` carrega também o filtro). Está escrito
 * por extenso em ConversationRow.tsx; os testes conferem que os dois nomes continuam iguais.
 */
export const CONVERSATION_ID_ATTRIBUTE = 'data-conversation-id';
/** Atributo do contêiner rolável da lista (ConversationListPane.tsx), usado se a conversa sumiu. */
export const CONVERSATION_LIST_ATTRIBUTE = 'data-conversation-list';

/**
 * Devolve o foco ao link da conversa `id` dentro de `root` ou, se ela não estiver na lista
 * (outra aba, ainda não carregada), à própria lista, para o foco nunca cair no `<body>`.
 * Não rola de forma brusca: o foco entra sem rolar e a linha só é trazida à vista se estiver
 * fora da área visível (`block: 'nearest'` rola o mínimo).
 */
export function focusConversationInList(root: ParentNode, id: string): boolean {
  const link = Array.from(
    root.querySelectorAll<HTMLElement>(`[${CONVERSATION_ID_ATTRIBUTE}]`),
  ).find((element) => element.getAttribute(CONVERSATION_ID_ATTRIBUTE) === id);
  const target = link ?? root.querySelector<HTMLElement>(`[${CONVERSATION_LIST_ATTRIBUTE}]`);
  if (!target) return false;
  target.focus({ preventScroll: true });
  // jsdom não implementa `scrollIntoView`.
  if (link && typeof link.scrollIntoView === 'function') link.scrollIntoView({ block: 'nearest' });
  return true;
}
